module.exports = __webpack_public_path__ + "img/1x.23b5f6f.jpg";